import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './shared/guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./features/home/home').then(m => m.HomeComponent)
  },
  {
    path: 'home',
    loadComponent: () => import('./features/home/home').then(m => m.HomeComponent)
  },
  {
    path: 'features',
    loadComponent: () => import('./features/features/features').then(m => m.FeaturesComponent)
  },
  {
    path: 'categories',
    loadComponent: () => import('./features/categories/categories').then(m => m.CategoriesComponent)
  },
  {
    path: 'coverage',
    loadComponent: () => import('./features/coverage/coverage').then(m => m.CoverageComponent)
  },
  {
    path: 'services',
    children: [
      {
        path: '',
        loadComponent: () => import('./features/services/services').then(m => m.ServicesComponent)
      },
      {
        path: ':id',
        loadComponent: () => import('./features/service-details/service-details').then(m => m.ServiceDetailsComponent)
      }
    ]
  },
  {
    path: 'providers',
    children: [
      {
        path: '',
        loadComponent: () => import('./features/providers/providers').then(m => m.ProvidersComponent)
      },
      {
        path: ':id',
        loadComponent: () => import('./features/provider-details/provider-details').then(m => m.ProviderDetailsComponent)
      }
    ]
  },
  {
    path: 'auth',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login'
      },
      {
        path: 'login',
        loadComponent: () => import('./features/auth/login/login').then(m => m.LoginComponent)
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./features/auth/forgot-password/forgot-password').then(m => m.ForgotPasswordComponent)
      },
      {
        path: 'signup',
        loadComponent: () => import('./features/auth/signup/signup').then(m => m.SignupComponent)
      },
      {
        path: 'provider-register',
        loadComponent: () =>
          import('./features/auth/provider-register/provider-register').then(m => m.ProviderRegisterComponent)
      },
      {
        path: 'upgrade',
        pathMatch: 'full',
        redirectTo: 'signup'
      },
      {
        path: 'reset-password',
        pathMatch: 'full',
        redirectTo: 'forgot-password'
      },
      {
        path: '**',
        redirectTo: 'login'
      }
    ]
  },
  {
    path: 'contact-us',
    loadComponent: () => import('./features/contact-us/contact-us').then(m => m.ContactUsComponent)
  },
  {
    path: 'help-center',
    pathMatch: 'full',
    redirectTo: 'faq'
  },
  {
    path: 'refund-policy',
    pathMatch: 'full',
    redirectTo: 'faq'
  },
  {
    path: 'faq',
    loadComponent: () => import('./features/faq/faq').then(m => m.FaqComponent)
  },
  {
    path: 'payment/callback',
    loadComponent: () => import('./features/payment-callback/payment-callback').then(m => m.PaymentCallbackComponent)
  },
  {
    path: 'payments-help',
    loadComponent: () => import('./features/payments-help/payments-help').then(m => m.PaymentsHelpComponent)
  },
  {
    path: 'provider-help',
    loadComponent: () => import('./features/provider-help/provider-help').then(m => m.ProviderHelpComponent)
  },
  {
    path: 'terms',
    loadComponent: () => import('./features/terms-and-conditions/terms-and-conditions').then(m => m.TermsAndConditionsComponent)
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./features/privacy-policy/privacy-policy').then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'account',
    loadComponent: () => import('./features/account/account').then(m => m.AccountComponent),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children:[
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'profile'
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/profile/profile').then(m => m.ProfileComponent)
      },
      {
        path: 'provider-status',
        loadComponent: () => import('./features/provider-status/provider-status.page').then(m => m.ProviderStatusPage)
      },
      {
        path: 'bookings',
        children: [
          {
            path: '',
            loadComponent: () => import('./features/bookings/bookings').then(m => m.BookingsComponent)
          },
          {
            path: 'new/:serviceId/:providerId/:categoryId',
            loadComponent: () =>
              import('./features/booking-create/booking-create').then(m => m.BookingCreateComponent)
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./features/booking-detail/booking-detail').then(m => m.BookingDetailComponent)
          }
        ]
      },
      {
        path: 'messages/:id',
        loadComponent: () => import('./features/conversation/conversation').then(m => m.ConversationComponent)
      },
      {
        path: '**',
        redirectTo: 'profile'
      }
    ]
  },
  {
    path: 'dashboard',
    pathMatch: 'full',
    redirectTo: 'admin/dashboard'
  },
  {
    path: 'login',
    pathMatch: 'full',
    redirectTo: 'auth/login'
  },
  {
    path: 'forgot-password',
    pathMatch: 'full',
    redirectTo: 'auth/forgot-password'
  },
  {
    path: 'signup',
    pathMatch: 'full',
    redirectTo: 'auth/signup'
  },
  {
    path: 'profile',
    pathMatch: 'full',
    redirectTo: 'account/profile'
  },
  {
    path: 'bookings',
    pathMatch: 'full',
    redirectTo: 'account/bookings'
  },
  {
    path: 'booking-create',
    pathMatch: 'full',
    redirectTo: 'account/bookings/new'
  },
  {
    path: 'messages/:id',
    pathMatch: 'full',
    redirectTo: 'account/messages/:id'
  },
  {
    path: 'admin',
    loadComponent: () => import('./shared/components/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
    canActivate: [adminGuard],
    canActivateChild: [adminGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () => import('./core/admin/dashboard/admin-dashboard.page').then(m => m.AdminDashboardPage)
      },

      // Jobs
      {
        path: 'jobs',
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'overview' },
          { path: 'overview', loadComponent: () => import('./core/admin/jobs/admin-jobs.page').then(m => m.AdminJobsPage) },
          { path: 'active', loadComponent: () => import('./core/admin/jobs/active-job/active-job.page').then(m => m.ActiveJobPage) },
          { path: 'available', loadComponent: () => import('./core/admin/jobs/available-jobs/available-jobs.page').then(m => m.AvailableJobsPage) },
          { path: 'completed', loadComponent: () => import('./core/admin/jobs/job-completion/job-completion.page').then(m => m.JobCompletionPage) },
          { path: ':id', loadComponent: () => import('./core/admin/jobs/job-details/job-details.page').then(m => m.JobDetailsPage) }
        ]
      },

      // Users
      {
        path: 'users',
        children: [
          { path: '', loadComponent: () => import('./core/admin/users/user-list/admin-users.page').then(m => m.AdminUsersPage) },
          { path: 'add', loadComponent: () => import('./core/admin/users/user-add/user-add.page').then(m => m.UserAddPage) },
          { path: 'edit/:id', loadComponent: () => import('./core/admin/users/user-add/user-add.page').then(m => m.UserAddPage) }
        ]
      },

      // Providers
      {
        path: 'providers',
        children: [
          { path: '', loadComponent: () => import('./core/admin/providers/provider-list/provider-list.page').then(m => m.ProviderListPage) },
          { path: 'add', loadComponent: () => import('./core/admin/providers/provider-add/provider-add.page').then(m => m.ProviderAddPage) },
          { path: 'edit/:id', loadComponent: () => import('./core/admin/providers/provider-edit/provider-edit.page').then(m => m.ProviderEditPage) },
          { path: 'view/:id', loadComponent: () => import('./core/admin/providers/provider-view/provider-view.page').then(m => m.ProviderViewPage) }
        ]
      },

      // Services
      {
        path: 'services',
        children: [
          { path: '', loadComponent: () => import('./core/admin/services/service-list/service-list.page').then(m => m.ServiceListPage) },
          { path: 'add', loadComponent: () => import('./core/admin/services/service-add/service-add.page').then(m => m.ServiceAddPage) },
          { path: 'edit/:id', loadComponent: () => import('./core/admin/services/service-edit/service-edit.page').then(m => m.ServiceEditPage) },
          { path: 'view/:id', loadComponent: () => import('./core/admin/services/service-view/service-view.page').then(m => m.ServiceViewPage) }
        ]
      },

      // Categories
      {
        path: 'categories',
        children: [
          { path: '', loadComponent: () => import('./core/admin/categories/category-list/category-list.page').then(m => m.CategoryListPage) },
          { path: 'add', loadComponent: () => import('./core/admin/categories/category-add/category-add.page').then(m => m.CategoryAddPage) },
          { path: 'edit/:id', loadComponent: () => import('./core/admin/categories/category-edit/category-edit.page').then(m => m.CategoryEditPage) }
        ]
      },

      // Subscriptions
      {
        path: 'subscriptions',
        children: [
          { path: '', loadComponent: () => import('./core/admin/subscriptions/subscription-list/subscription-list.page').then(m => m.SubscriptionListPage) },
          { path: 'add', loadComponent: () => import('./core/admin/subscriptions/subscription-add/subscription-add.page').then(m => m.SubscriptionAddPage) },
          { path: 'edit/:id', loadComponent: () => import('./core/admin/subscriptions/subscription-edit/subscription-edit.page').then(m => m.SubscriptionEditPage) },
          { path: 'view/:id', loadComponent: () => import('./core/admin/subscriptions/subscription-view/subscription-view.page').then(m => m.SubscriptionViewPage) }
        ]
      },

      // Payments
      {
        path: 'payments',
        children: [
          { path: '', loadComponent: () => import('./core/admin/payments/payments-admin/admin-payments.page').then(m => m.AdminPaymentsPage) },
          { path: 'paystack-accounts', redirectTo: 'paystack-credentials', pathMatch: 'full' },
          {
            path: 'paystack-credentials',
            children: [
              { path: '', loadComponent: () => import('./core/admin/payments/paystack-accounts/paystack-accounts.page').then(m => m.PaystackAccountsPage) },
              { path: 'add', loadComponent: () => import('./core/admin/payments/paystack-credentials/paystack-credentials-add/paystack-credentials-add.page').then(m => m.PaystackCredentialsAddPage) },
              { path: 'edit/:id', loadComponent: () => import('./core/admin/payments/paystack-credentials/paystack-credentials-add/paystack-credentials-add.page').then(m => m.PaystackCredentialsAddPage) }
            ]
          }
        ]
      },

      // Notifications, Messages
      { path: 'notifications', loadComponent: () => import('./core/admin/notifications/admin-notifications.page').then(m => m.AdminNotificationsPage) },
      { path: 'messages', loadComponent: () => import('./core/admin/messages/admin-messages.page').then(m => m.AdminMessagesPage) },

      // Activities
      { path: 'activities', loadComponent: () => import('./core/admin/activities/activity-list/activity-list.page').then(m => m.ActivityListPage) },
      { path: 'activities/:id', loadComponent: () => import('./core/admin/activities/activity-detail/activity-detail.page').then(m => m.ActivityDetailPage) },

      // Locations
      {
        path: 'locations',
        children: [
          { path: '', loadComponent: () => import('./core/admin/locations/location-list/location-list.page').then(m => m.LocationListPage) },
          { path: 'add', loadComponent: () => import('./core/admin/locations/location-add/location-add.page').then(m => m.LocationAddPage) },
          { path: 'edit/:id', loadComponent: () => import('./core/admin/locations/location-edit/location-edit.page').then(m => m.LocationEditPage) }
        ]
      },

      // Discounts
      {
        path: 'discounts',
        children: [
          { path: '', loadComponent: () => import('./core/admin/discounts/discount-list/discount-list.page').then(m => m.DiscountListPage) },
          { path: 'add', loadComponent: () => import('./core/admin/discounts/discount-add/discount-add.page').then(m => m.DiscountAddPage) },
          { path: 'edit/:id', loadComponent: () => import('./core/admin/discounts/discount-edit/discount-edit.page').then(m => m.DiscountEditPage) },
          { path: 'view/:id', loadComponent: () => import('./core/admin/discounts/discount-view/discount-view.page').then(m => m.DiscountViewPage) }
        ]
      },

      // Choose Account Type
      { path: 'choose-account-type', loadComponent: () => import('./core/admin/choose-account-type/choose-account-type.page').then(m => m.ChooseAccountTypePage) },

      // Misc / Tools
      { path: 'products', loadComponent: () => import('./core/admin/products/admin-products.page').then(m => m.AdminProductsPage) },
      { path: 'settings', loadComponent: () => import('./core/admin/settings/admin-settings.page').then(m => m.AdminSettingsPage) },
      { path: 'earnings', loadComponent: () => import('./core/admin/earnings/earnings.page').then(m => m.EarningsPage) },
      { path: 'payouts', loadComponent: () => import('./core/admin/payouts/admin-payouts.page').then(m => m.AdminPayoutsPage) },
      { path: 'ai-models', loadComponent: () => import('./core/admin/ai-models/ai-models.page').then(m => m.AiModelsPage) },
      { path: 'ai-agents', loadComponent: () => import('./core/admin/ai-agents/admin-ai-agents.page').then(m => m.AdminAiAgentsPage) },
      { path: 'config', loadComponent: () => import('./core/admin/config-editor/config-editor.page').then(m => m.ConfigEditorPage) },

      { path: '**', redirectTo: 'dashboard' }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
